import { FC, useContext, useEffect, useState } from 'react';

import { Button, InfoBlock } from '@smartshell/ui-kit';

import { AuthContext } from 'auth';
import { LocalizationContext } from 'localization';

import { ClubList } from '../../ClubList';
import { IUserClub } from '../../types';
import s from './Clubs.module.scss';

interface IClubsProps {
  clubs: Array<IUserClub>;
  onClubSelect: (id: number) => Promise<unknown>;
}

export const Clubs: FC<IClubsProps> = ({ clubs, onClubSelect }) => {
  const { t } = useContext(LocalizationContext);
  const {
    data: { error },
    actions: {
      loadMe: { loading: authorizationDataLoading },
    },
  } = useContext(AuthContext);

  const [selectedClubId, setSelectedClubId] = useState<number | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    setIsProcessing(authorizationDataLoading);
  }, [authorizationDataLoading]);

  return (
    <div className={s.container} data-testid="clubs">
      <header className={s.header}>{t('clubs.title')}</header>
      {error && <InfoBlock title={t(error.title)} message={t(error.message)} />}
      <div className={s['clubs']}>
        <ClubList
          selectedClubId={selectedClubId}
          setSelectedClubId={setSelectedClubId}
          clubs={clubs}
        />
        <Button
          onClick={() => {
            if (!selectedClubId) {
              return;
            }

            setIsProcessing(true);

            onClubSelect(selectedClubId).finally(() => {
              if (!authorizationDataLoading) {
                setIsProcessing(false);
              }
            });
          }}
          disabled={!selectedClubId}
          isLoading={isProcessing}
          fullWidth
        >
          {t('clubs.submit')}
        </Button>
      </div>
    </div>
  );
};
